module.exports = __webpack_public_path__ + "img/benefits.348f751d.svg";